export default {
  inclusion: "{description} n'est pas inclus dans la liste",
  exclusion: "{description} est réservé",
  invalid: "{description} n'est pas valide",
  confirmation: "{description} ne correspond pas au {on}",
  // accepted: // '{description} must be accepted',
  empty: "{description} ne doit pas être vide",
  // blank: "{description} doit être vide",
  present: "{description} ne peut être vide",
  // collection: // '{description} must be a collection',
  // singular: // "{description} can't be a collection",
  tooLong: "{description} est trop long ({max} caractères maximum)",
  tooShort: "{description} est trop court ({min} caractères minimum)",
  // between: // '{description} must be between {min} and {max} characters',
  // before: // '{description} must be before {before}',
  // onOrBefore: // '{description} must be on or before {onOrBefore}',
  // after: // '{description} must be after {after}',
  // onOrAfter: // '{description} must be on or after {onOrAfter}',
  // wrongDateFormat: // '{description} must be in the format of {format}',
  wrongLength: "{description} n'est pas de la bonne taille ({is} caractères)",
  notANumber: "{description} doit être un nombre",
  notAnInteger: "{description} doit être un nombre entier",
  greaterThan: "{description} doit être supérieur(e) à {gt}",
  greaterThanOrEqualTo:
    "{description} doit être supérieur(e) ou égal(e) à {gte}",
  equalTo: "{description} doit être égal(e) à {is}",
  lessThan: "{description} doit être inférieur(e) à {lt}",
  lessThanOrEqualTo: "{description} doit être inférieur(e) ou égal(e) à {lte}",
  // otherThan: // '{description} must be other than {value}',
  // odd: // '{description} must be odd',
  // even: // '{description} must be even',
  positive: "{description} doit être positif",
  // multipleOf: // '{description} must be a multiple of {multipleOf}',
  date: "{description} doit être une date valide",
  email: "{description} doit être une adresse email valide",
  phone: "{description} doit être un numéro de téléphone valide"
  // url: // '{description} must be a valid url'
};
